// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

// slick
import $ from 'jquery';
import 'third/slick.min.js';

export default class ContentSlider extends WebComponent {
  didMount() {
    const slider = this.element;

    $(slider).slick({
      autoplay: true,
      autoplaySpeed: 3000,
      mobileFirst: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      //prevArrow: $('.logos-slider__nav-prev'),
      //nextArrow: $('.logos-slider__nav-next'),
      infinite: true,
      speed: 500,
      cssEase: 'ease',
      draggable: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        }],
    });
    $(window).resize(function(){
      $(slider)[0].slick.refresh();
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ContentSlider.js